import { ReactNode, useRef } from 'react';
import TooltipContext from '@components/core/tooltip/tooltip-context.tsx';

const TooltipProvider = ({ children }: { children: ReactNode }) => {
	const containerRef = useRef<HTMLDivElement>(null);

	return (
		<TooltipContext.Provider value={containerRef}>
			<>
				{children}
				<div
					ref={containerRef}
					id="tooltip-container"
					className="fixed inset-0 pointer-events-none z-[9999]"
				/>
			</>
		</TooltipContext.Provider>
	);
};

export default TooltipProvider;
